var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRouteSplitIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.15 13.85L16.71 15.29L13.83 12.41L12.41 13.83L15.29 16.71L13.85 18.15C13.54 18.46 13.76 19 14.21 19H18.5C18.78 19 19 18.78 19 18.5V14.21C19 13.76 18.46 13.54 18.15 13.85ZM19 7.79V3.5C19 3.22 18.78 3 18.5 3L14.21 3C13.76 3 13.54 3.54 13.86 3.85L15.3 5.29L10.6 10H4C3.45 10 3 10.45 3 11C3 11.55 3.45 12 4 12L11 12C11.26 12 11.52 11.89 11.71 11.71L16.72 6.71L18.16 8.15C18.46 8.46 19 8.24 19 7.79Z",
    fill: "#04B7EF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRouteSplitIcon);
export default __webpack_public_path__ + "static/media/RouteSplitIcon.b9f5b87141285be436fe8bad9e07d92d.svg";
export { ForwardRef as ReactComponent };